export default __webpack_public_path__ + "locales/az/Translations.json?hash=c6be61f3c25e83457c1156b2cfe3083d";